import { ISelectFieldOption } from 'shared/Houston';

const offerTitleOptions: ISelectFieldOption[] = [
  { value: 'Oferta única', label: 'Oferta única' },
  { value: 'Oferta limitada', label: 'Oferta limitada' },
  { value: 'Oferta especial', label: 'Oferta especial' }
];

export default offerTitleOptions;
